<template>
    <header class="header-unlogged">
        <NavbarTop v-if="hasMultipleModes" />
        <Navbar />
    </header>
</template>
<script setup lang="ts">
    import Navbar from './Navbar.vue';
    import NavbarTop from './NavbarTop.vue';
    import {useNavbarMode} from '../composables/useNavbarMode';

    const {hasMultipleModes} = useNavbarMode();
</script>
<style lang="scss">
    :root {
        --navbar-height: 80px;
        --navbar-mobile-height: 44px;
        --navbar-offset: 20px;
        --navbar-top-height: 48px;
        --navbar-top-mobile-height: 64px;
        --navbar-transition-duration: 0.6s;
        --navbar-scroll-transition-duration: 0.2s;
        --navbar-transition-easing: cubic-bezier(0.4, 0, 0.2, 1);

        /* NavbarTop scrolls away in normal flow, so overlays only reserve the sticky bar. */
        --topnav-height: 0px;
    }

    /* `data-navbar-transparent` is in the SSR HTML; `.navbar--overlay` is added after hydration. */
    :root:not([data-navbar-transparent], :has(.navbar--overlay)) {
        --navbar-offset: 0px;
        --navbar-height: 60px;
    }

    /* The header must not box the bar in: a sticky Navbar can only stick within its parent. */
    .header-unlogged {
        display: contents;
    }
</style>
